<div class="searching-destinations-container">
    <app-custom-video src="../../../../../../assets/images/contact/buscando-destinos.webm" [width]=374></app-custom-video>
    <p class="text-destinations">Buscando los destinos ideales para ti...</p>
</div>